import { isDefined, schSavedPairCriteria } from '@aloft/toolkit-shared';

import { useWatch } from 'react-hook-form';
import { z } from 'zod';

export const countActivePairCriteria = (
  criteria: ReturnType<typeof useWatch<z.input<typeof schSavedPairCriteria>>>,
): number => {
  let count = 0;

  if (!!criteria.differenceCriteria?.p1 && criteria.differenceCriteria.p1.t !== 'any') {
    count += 1;
  }
  if (!!criteria.differenceCriteria?.p2 && criteria.differenceCriteria.p2.t !== 'any') {
    count += 1;
  }

  count += Object.values(criteria.matchCriteria ?? {}).filter(
    (x) => isDefined(x) && x.t !== 'any',
  ).length;

  return count;
};
